import { gql } from '@apollo/client';

export const DRIVER_LOCATION_SUBSCRIPTION = gql`
    subscription DriverLocation($tripId: Int!) {
        driverLocation(tripId: $tripId) {
            id
            latitude
            longitude
            timestamp
            tripId
        }
    }
`;

export const DRIVER_LOCATION_BY_SHARE_TOKEN = gql`
    subscription DriverLocationByShareToken($token: String!) {
        driverLocationByShareToken(token: $token) {
            latitude
            longitude
            timestamp
        }
    }
`;

export const TRIP_AUTO_COMPLETED_SUBSCRIPTION = gql`
    subscription TripAutoCompleted($tripId: Int!) {
        tripAutoCompleted(tripId: $tripId) {
            tripId
            completedAt
        }
    }
`;
